import { ConnectionManager, MessagePublisher, SubscriptionManager } from "./stomp";

/**
 * Thin facade over the STOMP modules.
 * Keeps the same public API so no call-sites need to change.
 */
class StompChatService {
  constructor() {
    this._conn = new ConnectionManager();
    this._pub = new MessagePublisher(this._conn);
    this._sub = new SubscriptionManager(this._conn);

    // Wire subscription manager into connection manager for reconnect logic
    this._conn._subscriptionManager = this._sub;
  }

  // --- Connection ---
  connect(jwtToken, onConnected, onMessage, onError) {
    this._conn.connect(jwtToken, onConnected, onMessage, onError);
  }
  disconnect() { this._conn.disconnect(); }
  isConnected() { return this._conn.isConnected(); }
  getConnectionStatus() { return this._conn.getConnectionStatus(); }

  // --- Lifecycle listeners ---
  onMessage(handler) { return this._conn.onMessage(handler); }
  onReconnect(handler) { return this._conn.onReconnect(handler); }

  // --- Publishing ---
  sendMessage(messageData, token) { this._pub.sendMessage(messageData, token); }
  sendTyping(token, typingData) { this._pub.sendTyping(token, typingData); }
  sendStopTyping(token, typingData) { this._pub.sendStopTyping(token, typingData); }
  sendGroupTyping(token, data) { this._pub.sendGroupTyping(token, data); }
  sendGroupStopTyping(token, data) { this._pub.sendGroupStopTyping(token, data); }
  sendGroupMessage(token, messageData) { this._pub.sendGroupMessage(token, messageData); }

  // --- Subscriptions ---
  subscribeTyping(cb) { this._sub.subscribeTyping(cb); }
  unsubscribeTyping() { this._sub.unsubscribeTyping(); }
  subscribeGroupMessages(cb, userId, groupId) { this._sub.subscribeGroupMessages(cb, userId, groupId); }
  unsubscribeGroupMessages() { this._sub.unsubscribeGroupMessages(); }
  subscribeSettings(orgId, cb) { this._sub.subscribeSettings(orgId, cb); }
  unsubscribeSettings() { this._sub.unsubscribeSettings(); }

  // --- Proxy properties for backward compat ---
  get currentChatId() { return this._conn.currentChatId; }
  set currentChatId(val) { this._conn.currentChatId = val; }
}

const stompChatService = new StompChatService();
export default stompChatService;
